import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName: string) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';

import React from 'react';
import { regroupModuleReducers, getServerSidePropsLoader } from '@rakutenfrance/redux-apollo-helper';

import { renderReact } from '../../fragmentHelper/renderReactCustom';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
// import '@rakutenfrance/seller-information-drawer/build/style.global.css';
import SellerInformationDrawerModule from '@rakutenfrance/seller-information-drawer';
import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';
import { tolgeeModule } from '@rakutenfrance/tolgee-provider';

export const serverCanCache = true;

const { SellerInformationDrawerContainer } = SellerInformationDrawerModule.containers;

const modules = [SellerInformationDrawerModule, tolgeeModule] as any[];
const reducers = regroupModuleReducers(modules);

const WrappedSellerInformationDrawer: React.FC<PagePropsType & { graphQlvariables: any; advertCrewModale: any }> = ({
  initialApolloState,
  initialReduxState,
  moduleName,
}) => {
  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      moduleName={moduleName}
      reducers={reducers}
    >
      <SellerInformationDrawerContainer />
  </ReduxApolloFragmentWrapperChildren>
  );
};
export const renderFunction = renderReact('SellerInformationDrawer', WrappedSellerInformationDrawer);


export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext) => {
  const baseUrl = "";
  const preloadedConfig = {};
  const graphQlVariables = {};
  const graphQlQuery = '';

  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );

  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};